// extracted by mini-css-extract-plugin
export default {"app":"app_app__ZSdIq","bg":"app_bg__+lSwT"};